import React, { useEffect, useState } from "react";
import ALoader from "views/pages/manage/common/a-loader";

const CountdownLoader = ({
  isLoaderActive,
  setIsLoaderActive,
  cancelTransaction,
  isShowCancelButton,
}) => {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes in seconds

  const initiate = async () => {
    setIsLoaderActive(true); // Start the loader
    console.log("Initiate function called");

    try {
      // Simulate an API call
      await fakeApiCall();
      console.log("API response received!");
    } catch (error) {
      console.error("Error fetching API:", error);
    } finally {
      // Stop the loader after the response
      setIsLoaderActive(false);
      setTimeLeft(15 * 60); // Reset timer if needed
    }
  };

  useEffect(() => {
    let timer;
    if (isLoaderActive) {
      timer = setInterval(() => {
        setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);
    }

    return () => clearInterval(timer); // Cleanup on unmount or when isLoaderActive changes
  }, [isLoaderActive]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  // Simulated API call (replace this with your real API logic)
  const fakeApiCall = () => {
    return new Promise((resolve) => {
      setTimeout(() => resolve(), 5000); // Simulate a 5-second delay
    });
  };

  return (
    <div style={{ textAlign: "center" }}>
      <>
        <div
          style={{ height: "212px" }}
          className="d-flex justify-content-center align-items-center flex-column"
        >
          <div className="mb-2">
            <ALoader position="relative" />
          </div>
          <div className="heading-4 text-bold text-dark mt-4">
            {formatTime(timeLeft)}
          </div>
          <div className="regular-large mt-1 text-center">
            Waiting for payment. Please be patient while
            <br />
            we receive the payment
          </div>
          {isShowCancelButton && (
            <span
              style={{ zIndex: 202, cursor: "pointer" }}
              className="text-danger mt-2 d-block"
              onClick={cancelTransaction}
            >
              Cancel transaction
            </span>
          )}
        </div>
      </>
    </div>
  );
};

export default CountdownLoader;
